export default __webpack_public_path__ + "static/media/doc-eco.d998e642.jpg";